//react
import React, {lazy, Suspense, useState, useEffect, useRef, useContext} from 'react';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import './styles/App.scss';

import Typography from '@mui/material/Typography';
//components
// import NavbarTabs from './components/NavbarTabs';
import { SoundContext } from './components/SoundContext';
import RecordPlayer from './components/RecordPlayer';
// import ToggleIconNav from './components/ToggleIconNav';
import NavbarMain from './components/NavBar/NavbarMain';
import ToggleIconNav from './components/NavBar/ToggleIconNav';

function App({onFontChange}) {
  const myPages = {
    Homepage: lazy(()=>import('./pages/Homepage')),
    Fiction:lazy(()=>import('./pages/Fiction')),
    Fanfiction: lazy(()=>import('./pages/Fanfiction')),
    Nonfiction: lazy(()=>import('./pages/Nonfiction')),
    About: lazy(()=>import('./pages/About')),
    Contact: lazy(()=>import('./pages/Contact')),
    Links: lazy(()=>import('./pages/Links'))
  }

  const myFictionPages = {
    TableForThree:lazy(()=>import('./pages/Stories/Fiction/TableForThree')),
    FatherSinclair:lazy(()=>import('./pages/Stories/Fiction/FatherSinclair')),
    ISeeASymphony:lazy(()=>import('./pages/Stories/Fiction/ISeeASymphony')),
    MadnessInABottle:lazy(()=>import('./pages/Stories/Fiction/MadnessInABottle')),
    Opia:lazy(()=>import('./pages/Stories/Fiction/Opia')),
    Fortuneteller:lazy(()=>import('./pages/Stories/Fiction/Fortuneteller')),
    FeedMySoul:lazy(()=>import('./pages/Stories/Fiction/FeedMySoul'))
  }
  /* const myNonFicPages = {

  }*/
  const myFanficPages = {
    GhostQueen:lazy(()=>import('./pages/Stories/Fanfiction/GhostQueen')),
    HuntersBoon:lazy(()=>import('./pages/Stories/Fanfiction/HuntersBoon'))
  } 

  const [currFont, setCurrFont] = useState('MyHandwritten');

  const handleFontChange = (font) =>{
    setCurrFont(font);
    onFontChange(font);

    document.body.classList.remove('font-myhandwritten', 'font-lexend');
    document.body.classList.add(`font-${font.toLowerCase()}`);
  }

  const {isSoundOn} = useContext(SoundContext);
  const [isPlaying, setIsPlaying] = useState(false);
  const [volume,setVolume] = useState(0.4);

  const audioRef = useRef(null);

  useEffect(
    ()=>{
      if(!audioRef.current){
        audioRef.current = new Audio('/audio/818414__collectionofmemories__vintage-piano-jazz.wav');
        audioRef.current.loop = true;
        audioRef.current.load();

        audioRef.current.volume = volume;
      }
    },[volume]
  );

  useEffect(
    ()=>{
      if(audioRef.current){
        if(isPlaying && isSoundOn){
          audioRef.current.play().catch(e=>console.error("Audio playback error :-(",e));

        }
        else{
          audioRef.current.pause();
        }
      }
    },[isPlaying, isSoundOn]
  );

  useEffect(()=>{
    console.log("Volume Effect triggered. Current volume:", volume);

    if(audioRef.current){
      audioRef.current.volume = volume;
    }
  },[volume]);

  const toggleMusic = ()=>{
    setIsPlaying(prevIsPlaying => {
      console.log("toggle music. Old isPlaying state: ",prevIsPlaying,"new isplaying: ", !prevIsPlaying);
      return !prevIsPlaying;
    } );
  };

  const handleVolumeChange = (event)=>{
    const newVolume = parseFloat(event.target.value);//volume comes in as string
    setVolume(newVolume);
  }

  return (
    <div className="App">
      <Suspense fallback={<div>Loading pages...</div>}>
        <Router>
          <header className="App-header">
            <div className="App-notebookContainer">
              {/* visible content here */}
              <div className="App-maincontent">
                <NavbarMain onFontChange={handleFontChange} currFont={currFont}/>
                <ToggleIconNav onFontChange={onFontChange} currFont ={currFont}/>
                <Routes>
                  {/*page routes */}
                  {
                    Object.entries(myPages).map(([name,Component])=>(
                      <Route
                        key={name}
                        path={`/pages/${name}`}
                        element={<Component/>}
                      />
                    ))
                  }
                  {
                    Object.entries(myFictionPages).map(([name,Component])=>(
                      <Route
                        key={name}
                        path={`/pages/Fiction/${name}`}
                        element={<Component/>}
                      />
                    ))
                  }
                  {
                    Object.entries(myFanficPages).map(([name,Component])=>(
                      <Route
                        key={name}
                        path={`/pages/Fanfiction/${name}`}
                        element={<Component/>}
                      />
                    ))
                  }
                  {/*load projects here */}

                  <Route path="/" element={<myPages.Homepage/>}/>
                </Routes>

                {/*Record player */}
                <div className="floor">
                  <div className="" onClick={toggleMusic}>
                    <RecordPlayer
                      soundState={isPlaying}
                      altText={isPlaying ? 'Record On' : 'Record Off'}
                    />
                  </div>

                  <div className="carpet">
                    <div className="textbubble">
                        {/* volume */}
                        <label htmlFor="volume-slider">
                          <Typography variant="body1">
                            Volume: 
                          </Typography>
                        </label>
                        <input
                          id="volume-slider"
                          type="range"
                          min="0"
                          max="1"
                          step="0.01"
                          value={volume}
                          onChange={handleVolumeChange}
                        />
                        <span>
                            <Typography variant="body1">
                              {Math.round(volume * 100)}%
                            </Typography>
                          
                        </span>
                      </div>
                  </div>
                </div>{/*record player */}
              </div>{/* main content */}
            </div>{/*note book container */}
          </header>
        </Router>
        
      </Suspense>
    </div>
  );
}

export default App;
